import {
	IonButton,
	IonCol,
	IonGrid,
	IonLabel,
	IonRow,
	IonText,
	IonIcon,
	IonModal,
} from "@ionic/react";
import "../global.scss";
import "../components/Portal/Confirmation/confirm.scss";
import React, { useState } from "react";
import * as constants from "../constants";
import { locationSharp, caretDownSharp } from "ionicons/icons";
import {
	COLLECTIONS,
	deleteDataFromFireStore,
	fireStoreDbInstance,
	setDefaultAddress,
} from "../firebase";
import {
	storeCurrentLatLong,
	storeUserMapAddress,
	updateVehicleDefaultAddress,
	storeUserEditAddressId,
	setDefAddress,
	saveAddressRef,
	deleteAddress,
	deleteCartItemList,
} from "../Store/Actions";
import Geocode from "react-geocode";
import { connect } from "react-redux";
import { checkMediaQuery } from ".";
import { AlertMessage } from "./alertMessage";
import { ToastMessage } from "./toastMessage";

const UserAddressModal: React.FC = (props: any) => {
	const { closeConfirmModal = () => null } = props;
	const [alertMessage, setMessage] = useState({
		showAlert: false,
		message: "",
		deleteCart: false,
		addressId: "",
	});
	const [showAddModal, setShowAddModal] = React.useState(false);
	const [toast, setToast] = React.useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});

	// console.log("get Cur Loc ====", props);

	const getUserCurrentLocation = () => {
		navigator.geolocation.getCurrentPosition(
			(resp) => {
				const { coords } = resp;
				// console.log("Lat lnh ====", coords);
				const { latitude, longitude } = coords;
				props.storeCurrentLatLong(latitude, longitude);
				Geocode.fromLatLng(latitude, longitude).then(
					(response: any) => {
						const address = response.results[0].formatted_address;
						storeUserMapAddress(address);
					},
					(error: any) => {
						console.error(error, "error");
					}
				);
			},
			(e: any) => {
				console.error(e, "e");
				if (e.message === "User denied Geolocation") {
					setToast({
						showToast: true,
						toastMessage: "Please provide location permission",
						severity: "warning",
					});
				}
			}
		);
	};

	const deleteAddressData = (addressId: any) => {
		deleteDataFromFireStore(
			props.uid,
			addressId,
			COLLECTIONS.USERS,
			COLLECTIONS.ADDRESSES
		);
		props.deleteAddress(addressId);
		const addressList = props.userAddressList.filter((ele: any) => ele.did !== addressId);
		if (addressList.length) {
			props.saveAddressRef(addressList[0].did);
		}
	};

	const changeSelectedLocationForVehicle = async (Addressdid: any) => {
		const vehicleId =
			(
				props.userVehiclesList.find(
					(ele: any) => ele.catalogVehicleId === props.sliderCatelogVehicleId
				) || {}
			).did || "";
		const vehicleData = props.userVehiclesList.find((ele: any) => ele.did === vehicleId);
		props.saveAddressRef(Addressdid);
		const payload = {
			...vehicleData,
			selectedAddressRef: Addressdid,
		};
		await props.updateVehicleDefaultAddress(payload);
		if (!!props.closeAddModal) {
			props.closeAddModal();
		} else {
			setShowAddModal(false);
		}
	};

	const setTheAdd = (id: any) => {
		const add_arr = props.userAddressList.filter((ele: any) => ele.did === id);
		props.onChangeAddress(add_arr);
		props.closeAddModal(false);
	};

	const getCurLocation = () => {
		getUserCurrentLocation();
		if (!!props.openMapModal) {
			props.closeAddModal();
			props.openMapModal();
		} else {
			props.history.push("/portal/add-new-address");
			setShowAddModal(false);
		}
	};

	const addNewAddressBtn = () => {
		if (!!props.closeAddModal) {
			props.closeAddModal();
			props.openMapModal();
		} else {
			setShowAddModal(false);
			props.history.push("/portal/add-new-address");
		}
	};

	const getAddressType = () => {
		if (
			props.userAddressList.length ||
			!!props.defaultAddressRef ||
			!!props.selectedAddressRef
		) {
			return (
				props.userAddressList.find((ele: any) => props.selectedAddressRef === ele.did) ||
				{}
			).addressType;
		}
	};

	const handleAddressDeletion = (did: string) => {
		if (did === props.selectedAddressRef && props.service_data.length) {
			setMessage({
				showAlert: true,
				message:
					"Are you sure you want to delete the address ? current services added to cart will be lost",
				deleteCart: true,
				addressId: did,
			});
		} else {
			setMessage({
				showAlert: true,
				message: constants.ARE_YOU_SURE_YOU_WANT_DELETE_ADDRESS,
				deleteCart: false,
				addressId: did,
			});
		}
	};

	const { path } = props.match;

	return (
		<>
			{!props.confirm && (
				<div className="address-modal-header" onClick={() => setShowAddModal(true)}>
					<img className="search_web" src="/images/web_location.svg" />
					<img className="search_res" src="/images/res_location.svg" />
					<IonLabel className="icon_label" color="secondary">
						{Boolean((props.userAddressList || []).length)
							? !!getAddressType()
								? getAddressType()
								: "Select Address"
							: "Select Address"}
					</IonLabel>
					<IonIcon icon={caretDownSharp}></IonIcon>
				</div>
			)}

			{/* {!props.confirm && (
      <div
        className="address-modal-header"
        onClick={() => setShowAddModal(true)}
      >
        <IonIcon icon={locationSharp}></IonIcon>
        <IonLabel className="icon_label" color="secondary">
          {Boolean((props.userAddressList || []).length) &&
          Boolean((props.userVehiclesList || []).length)
            ? (
                (props.userAddressList || []).find(
                  (val: any) =>
                    ((
                      props.userVehiclesList.find(
                        (ele: any) =>
                          ele.catalogVehicleId === props.sliderCatelogVehicleId
                      ) || {}
                    ).selectedAddressRef || "") === val.did
                ) || {}
              ).addressType || "Select Address"
            : !!(
                props.defaultAddressRef &&
                (props.userAddressList || []).find(
                  (val: any) =>
                    (props.defaultAddressRef.split("/").pop() || "") === val.did
                )
              )
            ? (
                (props.userAddressList || []).find(
                  (val: any) =>
                    (props.defaultAddressRef.split("/").pop() || "") === val.did
                ) || {}
              ).addressType
            : "Select Address"}
        </IonLabel>
        <IonIcon icon={caretDownSharp}></IonIcon>
      </div> )} */}

			<IonModal
				isOpen={!!props.showAddModal ? props.showAddModal : showAddModal}
				backdropDismiss={true}
				onDidDismiss={() => {
					!!props.showAddModal ? props.closeAddModal() : setShowAddModal(false);
				}}
				cssClass={!!props.confirm ? "confirm_picker-modal" : ""}
			>
				<div className={!!props.confirm ? "modal_body add_adress_pop_up" : "modal_body"}>
					<div className={!!props.confirm ? "confirm_modal_panel" : "modal_panel"}>
						<IonText className="modal_header">{constants.SELECT_YOUR_ADDRESS}</IonText>
						<img
							className="close_icon"
							onClick={() => {
								!!props.closeAddModal ? props.closeAddModal() : setShowAddModal(false);
							}}
							src="/images/close_popup.svg"
						/>
					</div>
					<div className="loc_pointer_par ">
						<img src="/images/green_cur_loc.svg" className="loc_pointer" />
						<div className="cur_loc_text_par">
							<IonLabel className="cur_loc_text" onClick={() => getCurLocation()}>
								{constants.CURRENT_LOCATION}
							</IonLabel>
							<IonLabel className="using_gps_text">{constants.USING_GPS}</IonLabel>
						</div>
					</div>
					<div className="address-wrapper responsive_address web_address">
						{(props.userAddressList || []).map((ele: any, index: any) => (
							<div
								key={index}
								className={
									!!props.confirm
										? "address-pill confirm_address_pill additional_pill_style "
										: "address-pill additional_pill_style"
								}
							>
								{/* <div
                  className={
                    (props.defaultAddressRef || "").split("/").pop() === ele.did
                      ? "defadd-container"
                      : "defadd-container-empty"
                  }
                >
                  {(props.defaultAddressRef || "").split("/").pop() ===
                    ele.did && (
                    <IonLabel className="defadd-text">{""}</IonLabel>
                  )}
                </div> */}
								<div
									onClick={() =>
										props.confirm
											? setTheAdd(ele.did)
											: changeSelectedLocationForVehicle(ele.did)
									}
								>
									<div className="default_label_parent">
										<IonLabel className="address-type">{ele.addressType}</IonLabel>
										{(props.defaultAddressRef || "").split("/").pop() === ele.did && (
											<div className="bg_color_label">
												<IonLabel
													style={{
														color: "#38c172",
														fontSize: 8,
														fontWeight: 800,
													}}
												>
													{constants.DEFAULT}
												</IonLabel>
											</div>
										)}
									</div>
									<IonLabel className="address-fulladd">
										{ele.addressline1}
										{", "}
										{ele.landmark}
										{", "}
										{ele.city}
										{", "}
										{ele.postalCode}
										{", "}
										{ele.country}
									</IonLabel>
								</div>
								<div className="address-action">
									<IonButton
										className="action-text"
										onClick={() => {
											closeConfirmModal();
											props.storeUserEditAddressId(ele.did);
											setShowAddModal(false);
											props.history.push(`/portal/edit-address/${ele.did}`);
										}}
									>
										{constants.EDIT} |{" "}
									</IonButton>
									<IonButton
										className="action-text"
										onClick={() => handleAddressDeletion(ele.did)}
									>
										{constants.DELETE}
									</IonButton>
									{(props.defaultAddressRef || "").split("/").pop() !== ele.did && (
										<IonButton
											className="action-text"
											onClick={() => {
												setDefaultAddress(
													props.uid,
													ele.did,
													COLLECTIONS.USERS,
													COLLECTIONS.ADDRESSES
												);
												props.setDefAddress(
													`${COLLECTIONS.USERS}/${props.uid}/${COLLECTIONS.ADDRESSES}/${ele.did}`
												);
												props.saveAddressRef(ele.did);
											}}
										>
											{" "}
											| {constants.MAKE_DEFAULT}
										</IonButton>
									)}
								</div>
							</div>
						))}
					</div>
					<div
						className="btn_parent_div modal-button"
						onClick={() => addNewAddressBtn()}
						style={{
							marginRight: 25,
							marginLeft: 25,
							width: "-webkit-fill-available",
						}}
					>
						<IonButton
							color="customgreen"
							className="continue_btn child_btn res_mg_top_0"
							style={{
								marginBottom: 30,
								minWidth: "auto",
								width: "100%",
								maxWidth: checkMediaQuery() ? "none" : 320,
							}}
						>
							<IonLabel color="customwhite">{constants.ADD_NEW_ADDRESS}</IonLabel>
						</IonButton>
					</div>
				</div>
			</IonModal>
			<AlertMessage
				showAlert={alertMessage.showAlert}
				alertMessage={alertMessage.message}
				onDidDismiss={() => {
					setMessage({
						showAlert: false,
						message: alertMessage.message,
						deleteCart: false,
						addressId: "",
					});
				}}
				alertHeader={constants.DELETE_ADDRESS}
				actionItemForAlert={async () => {
					deleteAddressData(alertMessage.addressId);
					if (alertMessage.deleteCart) {
						await props.deleteCartItemList();
					}
					setMessage({
						showAlert: false,
						message: alertMessage.message,
						deleteCart: false,
						addressId: "",
					});
				}}
				cssClass="alert-message"
			/>
			<ToastMessage
				showToast={toast.showToast}
				ToastMessage={toast.toastMessage}
				severity={toast.severity}
				onDidDismiss={() => {
					setToast({
						showToast: false,
						toastMessage: "",
						severity: "",
					});
				}}
			/>
		</>
	);
};

export default connect(({ userInfo }: any) => ({ ...userInfo }), {
	storeCurrentLatLong,
	storeUserMapAddress,
	setDefAddress,
	updateVehicleDefaultAddress,
	storeUserEditAddressId,
	deleteAddress,
	saveAddressRef,
	deleteCartItemList,
})(UserAddressModal);
